<template>
  <v-hover v-slot="{ hover }">
    <v-list-item v-on="hasClickListener ? { click: () => $emit('click') } : {}">
      <slot name="icon"></slot>
      <v-skeleton-loader v-if="item.loading" type="list-item-three-line" />
      <v-list-item-content v-else>
        <v-list-item-title class="text-truncate">
          <a v-if="hasOpenDetailListener" @click.stop="emitOpenDetail">
            {{ title || "-" }}
          </a>
          <span v-else> {{ title || "-" }} </span>
          <span>
            <v-chip
              :color="getState(item).color"
              v-if="item.state && item.state !== 'active'"
              x-small
              class="mx-1"
              dark
            >
              {{ $t(`views.fleet.FleetVehicleListView.state.${item.state}`) }}
            </v-chip>
          </span>
        </v-list-item-title>
        <v-list-item-subtitle class="text-xs" v-if="!small">
          <span v-if="item.numberplate"> {{ item.numberplate }} </span>
          <span v-if="item.identificationnumber">({{ item.identificationnumber }})</span>
        </v-list-item-subtitle>
        <v-list-item-subtitle v-if="!small" class="text-xs text-truncate">
          <span v-if="item.registration && item.registration.initialRegistrationDate">
            {{ item.registration.initialRegistrationDate }}
          </span>
          <span v-if="item.registration">
            {{ item.registration.manufacturerName }} {{ item.registration.manufacturerDescription }}
            {{ item.registration.manufacturerType }}
          </span>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action class="mx-0 px-0" v-if="confirmable">
        <tooltip :text="$t('common.BackendResourceEnum.click.tooltip.vehicle')" v-if="isConfirmable">
          <v-flex>
            <v-btn v-if="hover" text color="success" elevation="0" small @click="confirm">
              {{ $t(`common.BackendResourceEnum.click.vehicle`) }}
              <v-icon small class="pl-1"> mdi-check </v-icon>
            </v-btn>
          </v-flex>
        </tooltip>
      </v-list-item-action>
    </v-list-item>
  </v-hover>
</template>

<script lang="ts">
import { VehicleStateEnum } from "@/lib/enum/vehicleState.enum";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { GoToHelper } from "@/lib/utility/goToHelper";
import { IVehicle } from "@/models/vehicle.entity";
import { VehicleModule } from "@/store/modules/vehicle.store";
import { Component, Prop } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";
import Tooltip from "./tooltip.vue";

@Component({
  components: { Tooltip },
  filters: { simpleDoubleDigitDate }
})
export default class RefsVehicle extends BaseRef<IVehicle> implements IRefDetail<IVehicle> {
  @Prop()
  item!: IVehicle;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: false })
  confirmable!: boolean;

  get title() {
    return this.item.displayName || this.item.numberplate || this.item.identificationnumber;
  }

  get isConfirmable() {
    return Boolean(this.item.state !== VehicleStateEnum.ACTIVE);
  }

  goToDetail(openInNew = true) {
    new GoToHelper(this.$router).goToVehicleDetail(this.item.id, this.item.partnerId, undefined, openInNew);
  }

  get hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  get hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }

  getState(item: IVehicle) {
    if (!item.state) {
      return { color: "Grey", label: "" };
    }

    return VehicleModule.stateMap.get(item.state);
  }

  confirm() {
    this.$log.debug("confirm");
    this.confirmAsync();
    this.$emit("confirm", this.item);
  }

  async confirmAsync() {
    this.item.state = VehicleStateEnum.ACTIVE;

    await this.item.update();
  }
}
</script>
